import { useState } from "react";
import noResultFound from "../../assets/images/no-result-found.svg";
import startTyping from "../../assets/images/default-search-state.svg";

export default function NoResultFoundComponent({
  isFocused,
  searchValue,
  currentItems,
}) {
  return isFocused ? (
    currentItems?.length > 0 ? (
      searchValue ? (
        <></>
      ) : (
        <div className="flex flex-col w-full items-center justify-center gap-y-4 mt-10">
          <span className="text-black text-[25px] ">
            Type to Start Searching!
          </span>

          <img
            src={startTyping}
            className="w-[133px] h-[133px]"
            onClick={onclose}
          />
        </div>
      )
    ) : (
      <div className="flex flex-col w-full items-center justify-center gap-y-4 mt-10">
        <span className="text-black text-[25px] ">No Results Found</span>

        <img
          src={noResultFound}
          className="w-[133px] h-[133px]"
          onClick={onclose}
        />
      </div>
    )
  ) : (
    <></>
  );
}
